//import React from 'react';


export { default as className } from 'merge-class-names'; // https://github.com/wojtekmaj/merge-class-names

export { default as ref } from 'merge-refs';

export const eventProxy = (...listeners) => (event) => listeners.every((listener) => { if (typeof listener !== 'function') return true; listener(event); return !event.defaultPrevented });
